import { render, staticRenderFns } from "./vip_buy.vue?vue&type=template&id=5b1b03f9&"
import script from "./vip_buy.vue?vue&type=script&lang=js&"
export * from "./vip_buy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports